import { render, staticRenderFns } from "./SelfSignupError.vue?vue&type=template&id=60cb9ea6&scoped=true&"
import script from "./SelfSignupError.vue?vue&type=script&lang=js&"
export * from "./SelfSignupError.vue?vue&type=script&lang=js&"
import style0 from "./SelfSignupError.vue?vue&type=style&index=0&id=60cb9ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cb9ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
